function initializeBeamContact(root = document) {
  root.querySelectorAll('[data-beam-contact-page]').forEach((page) => {
    if (page.dataset.contactInitialized) return;
    page.dataset.contactInitialized = 'true';
    const selector = page.querySelector('[data-beam-enquiry]');
    const panels = Array.from(page.querySelectorAll('[data-enquiry-panel]'));
    const validMode = (mode) => panels.some((panel) => panel.dataset.enquiryPanel === mode);
    const selectMode = (mode, updateUrl = false) => {
      if (!validMode(mode)) mode = page.dataset.initialMode;
      selector.value = mode;
      panels.forEach((panel) => {
        const active = panel.dataset.enquiryPanel === mode;
        panel.hidden = !active;
        panel.querySelectorAll('input, select, textarea, button').forEach((field) => { field.disabled = !active; });
      });
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('enquiry', mode);
        url.searchParams.delete('contact_posted');
        url.hash = '';
        window.history.replaceState(null, '', url);
      }
    };
    const modeFromUrl = () => {
      const url = new URL(window.location.href);
      const formMode = panels.find((panel) => `#${panel.querySelector('form').id}` === url.hash)?.dataset.enquiryPanel;
      return formMode || url.searchParams.get('enquiry') || page.dataset.initialMode;
    };
    selectMode(modeFromUrl());
    page.querySelector('.beam-contact__selector').hidden = false;
    selector.addEventListener('change', () => selectMode(selector.value, true));
    window.addEventListener('popstate', () => selectMode(modeFromUrl()));
  });
  root.querySelectorAll('.beam-contact__form').forEach((form) => {
    if (form.dataset.contactInitialized) return;
    form.dataset.contactInitialized = 'true';
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product')?.trim().slice(0, 250);
    const reseller = params.get('reseller')?.trim().slice(0, 250);
    const productSelect = form.querySelector('[name="contact[product]"]');
    const products = form.querySelector('[name="contact[products]"]');
    const resellerField = form.querySelector('input[name="contact[reseller]"]');
    const message = form.querySelector('[name="contact[body]"]');
    if (productSelect && product) {
      const option = Array.from(productSelect.options).find((item) => item.value.toLowerCase() === product.toLowerCase());
      if (option) productSelect.value = option.value;
    }
    if (product && products && !products.value) products.value = product;
    if (reseller && resellerField) resellerField.value = reseller;
    if (product && message && !message.value && !products) message.value = `Product: ${product}\n\n`;
    ['interests', 'networks'].forEach((group) => {
      const boxes = Array.from(form.querySelectorAll(`[data-required-group="${group}"]`));
      if (!boxes.length) return;
      const validate = () => boxes[0].setCustomValidity(boxes.some((box) => box.checked) ? '' : 'Please select at least one option.');
      boxes.forEach((box) => box.addEventListener('change', validate));
      validate();
    });
    form.addEventListener('submit', () => {
      const firstName = form.querySelector('[name="contact[first_name]"]').value.trim();
      const lastName = form.querySelector('[name="contact[last_name]"]').value.trim();
      form.querySelector('[name="contact[name]"]').value = `${firstName} ${lastName}`.trim();
      const panel = form.closest('[data-enquiry-panel]');
      const returnTo = form.querySelector('[name="return_to"]');
      if (panel && returnTo) {
        const url = new URL(window.location.href);
        url.searchParams.set('enquiry', panel.dataset.enquiryPanel);
        url.searchParams.delete('contact_posted');
        url.hash = form.id;
        returnTo.value = `${url.pathname}${url.search}${url.hash}`;
      }
    });
  });
}
initializeBeamContact();
document.addEventListener('shopify:section:load', (event) => initializeBeamContact(event.target));
